import React from 'react';
import { cardsData } from './cardsData';

const MainCards = ({ onCardClick }) => {
  return (
    <div className="p-4 md:p-8 bg-gray-50 min-h-screen">
      <h2 className="text-2xl font-bold text-gray-800 mb-6">Learn more about the Internal Audit Process</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {cardsData.map((card) => (
          <div
            key={card.id}
            className="bg-white border border-gray-200 rounded-lg shadow hover:shadow-md cursor-pointer p-6"
            onClick={() => onCardClick(card.id)}
          >
            <h3 className="text-xl font-semibold mb-2">{card.title}</h3>
            <p className="text-gray-600">{card.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MainCards;
